import React from 'react';
import { FormSwitch } from 'src/js/component/base/form/form-switch';
import { FormSelect } from 'src/js/component/base/form/form-select';
import { NicOptions } from './services';
import { FormChangeEvent } from 'src/js/util/global-type';
interface Props {
  serviceKey: string;
  serviceLabel: string;
  dropdownLabel: string;
  checked: boolean;
  loading: boolean;
  nicValue: string;
  nicOptions: NicOptions;
  onServiceChange: (checked: boolean) => Promise<any> | void;
  onServiceNicChange: (formEvent: FormChangeEvent) => void;
  disabled?: boolean;
}

export const ServiceToggle: React.FunctionComponent<Props> = ({
  serviceKey,
  serviceLabel,
  dropdownLabel,
  checked,
  loading,
  nicValue,
  nicOptions,
  onServiceChange,
  onServiceNicChange,
  disabled = false,
}) => {
  const handleServiceChange = (checked: boolean) => {
    onServiceChange(checked);
  };

  return (
    <div className="mk-non-overlapping-grid">
      <FormSwitch
        checked={checked}
        loading={loading}
        switchLabel={serviceLabel}
        switchClassName="equal-width"
        container={true}
        onChange={handleServiceChange}
        disabled={disabled}
      />
      <FormSelect
        name={serviceKey}
        title={dropdownLabel}
        defaultSelect={nicValue}
        defaultValue={nicValue?.toLowerCase()}
        onChange={onServiceNicChange}
        options={nicOptions}
      />
    </div>
  );
};
